import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import { TextRepresentation } from '../FBRTypes';
import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const getIndicatorId = (function() {
	let indicatorIdSequence = 0;
	return () => {
		indicatorIdSequence++;
		return indicatorIdSequence;
	}
})();

const createChoiceResultIndicator = (
	icon: PIXI.Texture | null,
	textRepresentation: TextRepresentation | null, 
	startX: number, 
	startY: number, 
	yStepAmount: number,
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	centerOffsetContainerRef: MutableRefObject<PIXI.Container | undefined>,
	indicatorsRef: MutableRefObject<{[key:number]:FBRTypes.ChoiceResultIndicator} | undefined>,
) => {
	let id:number = getIndicatorId();
	let x = startX;
	let y = startY;
	if(pixiAppRef.current != null) {
		x = startX - (pixiAppRef.current.screen.width/2);
		y = startY - (pixiAppRef.current.screen.height/2);
	}
	let cycleCount = 0;
	let container = new PIXI.Container();
	container.x = x;
	container.y = y;

	//if(type === IndicatorType.text && text != null) {
	//} else if (type === IndicatorType.icon && icon != null) {
	if(icon != null) {
		const iconLabel = new PIXI.Sprite(icon);
		iconLabel.anchor.set(0.5,0.5);
		container.addChild(iconLabel);
	}
	//}
	if(textRepresentation != null) {
		const textLabel = new PIXI.Text(
			textRepresentation.textContent, 
			textRepresentation.pixiTextConfig
		);
		textLabel.anchor.set(0.5,0.5);
		container.addChild(textLabel);
	}

	if(centerOffsetContainerRef.current != null) {
		centerOffsetContainerRef.current.addChild(container);
	}
	const _update = (delta:number) => {
		if(cycleCount > FBRConstants.CHOICE_RESULT_INDICATOR_DESTROY_AFTER_STEPS) {
			container.destroy();
			if(indicatorsRef.current != null) {
				delete indicatorsRef.current[id];
			}
		} else {
			if(cycleCount > 5) {
				container.y += yStepAmount;
			}
			if(cycleCount > FBRConstants.CHOICE_RESULT_INDICATOR_DESTROY_AFTER_STEPS-20) {
				container.alpha -= 0.05;
			}
			cycleCount++;
		}
	};

	return {
		id: id,
		update: _update,
	}
};

export default createChoiceResultIndicator;
